module.exports = {
      id: "highlights-usage",
      viewBox: "0 0 19 18",
      url: __webpack_public_path__ + "svg-sprite.svg#highlights",
      toString: function () {
        return this.url;
      }
    }